window.park.app({
  container: 'suppressible',
  component: 'suppressible',
});



// WEBPACK FOOTER //
// ./src/widgets/suppressible/suppressible.js